import { Alert, Col, Input, Row } from "antd";
import { useForgotPasswordMutation } from "api/User/hooks.ts";
import { GeneralFormProvider } from "components/UI/GeneralForm/GeneralFormProvider";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { AuthFormWrapper } from "components/Wrappers/AuthFormWrapper/AuthFormWrapper.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { FormItem } from "react-hook-form-antd";
import { toast } from "react-toastify";

import { ForgotPasswordFormData, schema } from "./formSchema";

const ForgotPasswordFormContent: FC = () => {
    const { t: tF } = usePaldockTranslation("forms.forgot-password");
    const { t: tAuth } = usePaldockTranslation("auth.forgot-password");
    const { t: tFields } = usePaldockTranslation("forms.general-fields");
    const generalFormUtils = useGeneralForm<ForgotPasswordFormData>();
    const { control, fieldNames } = generalFormUtils;

    return (
        <AuthFormWrapper
            buttonText={tF("actions.reset_password")}
            hideLogo
            beforeButton={
                <Alert
                    message={tAuth("info")}
                    type="warning"
                    showIcon
                    className="mt-2"
                    style={{ boxShadow: "0px 3px 6px -4px #0000001F", border: "none" }}
                />
            }
        >
            <Row gutter={16}>
                <Col span={24}>
                    <FormItem
                        control={control}
                        name={fieldNames.email.name}
                        label={tFields("email.label")}
                        className="!mb-0"
                    >
                        <Input placeholder={tFields("email.placeholder")} />
                    </FormItem>
                </Col>
            </Row>
        </AuthFormWrapper>
    );
};

interface ForgotPasswordFormProps {
    returnUrl?: string;
}

export const ForgotPasswordForm: FC<ForgotPasswordFormProps> = ({
    returnUrl = `${import.meta.env.VITE_APP_URL}/auth/change-password`,
}) => {
    const { t: tF } = usePaldockTranslation("forms.forgot-password");

    const defaultValues = {
        email: "",
    };

    const forgotPasswordMutation = useForgotPasswordMutation({
        onSuccess: () => {
            toast.success(tF("messages.reset_link_sent"));
        },
    });

    const onSubmit = (data: ForgotPasswordFormData) => {
        forgotPasswordMutation.mutate({
            ...data,
            return_url: returnUrl,
        });
    };

    return (
        <GeneralFormProvider<ForgotPasswordFormData>
            schema={schema}
            defaultValues={defaultValues}
            onSubmit={onSubmit}
            requiredMark={false}
        >
            <ForgotPasswordFormContent />
        </GeneralFormProvider>
    );
};
